import Vue from 'vue'

export const EMAIL_SUBSCRIPTION_TYPES = {
  preFilledNewsletterCheckbox: 'preFilledNewsletterCheckbox',
}

export default {
  namespaced: true,
  state: {
    emailSubscriptions: {},
  },

  mutations: {
    addEmailSubscriptions(state, emailSubscriptions) {
      for (const [type, subscription] of Object.entries(emailSubscriptions)) {
        const email = subscription.email || ''
        if (!state.emailSubscriptions[email]) Vue.set(state.emailSubscriptions, email, {})
        Vue.set(state.emailSubscriptions[email], type, subscription)
      }
    },
  },

  getters: {
    getEmailSubscriptions: state => email => state.emailSubscriptions[email] || {},
    getEmailSubscriptionsByType: (state, getters) => (email, type) =>
      getters.getEmailSubscriptions(email)[type] || {},
  },
}
